import { NormalizedVoucher, FeatureAppStepCitaMode } from '@esportal/portal-service';
import { FeatureAppEnvironment, FeatureServices } from '@feature-hub/core';
import { FeatureAppLoader } from '@feature-hub/react';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { FeatureAppConfiguration } from '@volkswagen-onehub/featureapp-service';
import * as React from 'react';
import { Environment } from '../../../enviroment';
import { useFeatureService } from '../../../context/portal-context';

export function StepCita({ voucher, mode }: { voucher: NormalizedVoucher; mode: FeatureAppStepCitaMode }) {
	const { 'featureapp-service': featureappServiceV1 } = useFeatureService();

	const featureAppCitaConfig: FeatureAppConfiguration =
		featureappServiceV1.featureAppConfigurations[Environment.getInstance()[mode]];

	const beforeCreate = (env: FeatureAppEnvironment<FeatureServices, any>): void => {
		const faContentService = env.featureServices['fa-content-service'] as FaContentServiceV1;

		faContentService.content = {
			featureApp: 'es-bono',
			bono: [
				{
					desc: voucher?.card.title, // Descriptivo del bono para el asesor
				},
			],
		};
	};

	return (
		<>
			<FeatureAppLoader
				featureAppId={Environment.getInstance()[mode] as string}
				baseUrl={`${featureAppCitaConfig.baseUrl}`}
				src={`${featureAppCitaConfig.src}`}
				serverSrc={featureAppCitaConfig.serverSrc}
				config={featureAppCitaConfig.config}
				beforeCreate={beforeCreate}
			/>
		</>
	);
}
